<template>
  <div>
    <PackagesManagerOrdersGeneratorPricingList1D />
  </div>
</template>

<script>
import PackagesManagerOrdersGeneratorPricingList1D from "./PackagesManagerOrdersGeneratorPricingList1D.vue";
import { usePackagesManagerModule } from "@/state/pinia/packagesManagerModule";
import { useSimplepharmAuthModule } from "@/state/pinia/simplepharmAuthModule";
import { useCommonAppModule } from "@/state/pinia/commonAppModule";
import { useLazyLoaderModule } from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PackagesManagerOrdersGeneratorPricingStage",
  components: { PackagesManagerOrdersGeneratorPricingList1D },
  computed: {
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>


